import { useEffect, useState } from 'react'
import { FieldError } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import {
  ErrorText,
  ToggleButton,
  ToggleButtonGroup,
  Wrapper,
} from './DayOfWeekPicker.style'
import {
  formatDays,
  getWeekdayToggleOptions,
  toggleDay,
} from './daysOfWeekPicker.utils'

interface DayOfWeekPickerProps {
  onChange: (daysOfWeek: string[]) => void
  error: FieldError[] | undefined
  currentDays?: string[]
  disabled?: boolean
}

const DayOfWeekPicker = ({
  onChange,
  error,
  currentDays,
  disabled = false,
}: DayOfWeekPickerProps) => {
  const { t } = useTranslation()
  const currentDaysKey = currentDays?.join(',') || ''

  const [selectedDays, setSelectedDays] = useState<string[]>(
    formatDays(currentDays || [])
  )

  useEffect(() => {
    setSelectedDays(formatDays(currentDays || []))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentDaysKey])

  const daysOfWeek = getWeekdayToggleOptions()

  const handleDayChange = (event: React.MouseEvent<HTMLElement>) => {
    const clickedDay = (event.currentTarget as HTMLButtonElement).value
    const newDays = toggleDay(selectedDays, clickedDay)

    setSelectedDays(newDays)
    onChange(newDays.map(day => day.toUpperCase()))
  }

  return (
    <Wrapper>
      <ToggleButtonGroup
        value={selectedDays}
        aria-label="day of week"
        disabled={disabled}
      >
        {daysOfWeek.map(day => (
          <ToggleButton
            key={day.englishName}
            value={day.englishName}
            aria-label={day.localizedName}
            onClick={handleDayChange}
          >
            {t(day.localizedName)}
          </ToggleButton>
        ))}
      </ToggleButtonGroup>
      {error && selectedDays.length === 0 && (
        <ErrorText variant="caption">{t('validation.required')}</ErrorText>
      )}
    </Wrapper>
  )
}

export default DayOfWeekPicker
